import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PwaInstallService } from '../../services/pwa-install.service';

/**
 * Small-screen install prompt, fixed to the bottom of every page (it lives in
 * the root component). Large screens use the toolbar button instead.
 */
@Component({
  selector: 'app-pwa-install-floater',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './pwa-install-floater.component.html'
})
export class PwaInstallFloaterComponent {
  private readonly pwa = inject(PwaInstallService);

  readonly visible = this.pwa.showFloater;
  /** Browsers without a prompt get a walkthrough, so the label says so. */
  readonly actionLabel = () => (this.pwa.mode() === 'native' ? 'Install' : 'Show me how');

  install(): void {
    this.pwa.install();
  }

  dismiss(): void {
    this.pwa.dismissFloater();
  }
}
